var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameSwitchSec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 44,
    viewBox: "0 0 26 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34257",
    "data-name": "Group 34257",
    transform: "translate(-327 -517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34145",
    "data-name": "Group 34145",
    transform: "translate(1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12913",
    "data-name": "Rectangle 12913",
    width: 26,
    height: 44,
    transform: "translate(326 518)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34144",
    "data-name": "Group 34144",
    transform: "translate(6338.594 -5449.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12895",
    "data-name": "Rectangle 12895",
    width: 27.615,
    height: 16.962,
    transform: "translate(-5988.249 5976.297) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12896",
    "data-name": "Rectangle 12896",
    d: "M0,0H0A4.9,4.9,0,0,1,4.9,4.9v7.089A4.9,4.9,0,0,1,0,16.9H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(-5988.249 6003.893) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12897",
    "data-name": "Rectangle 12897",
    d: "M0,0H27.6a0,0,0,0,1,0,0V0a5.459,5.459,0,0,1-5.459,5.459H5.459A5.459,5.459,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(-6005.135 5976.317) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57976",
    "data-name": "Path 57976",
    d: "M-5991.7,5976.32v-2.22a1.976,1.976,0,0,1,1.47-1.91l6.61-1.75a1.963,1.963,0,0,1,1.024,0l6.4,1.74a1.977,1.977,0,0,1,1.458,1.907v2.23Z",
    transform: "translate(-13.508 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34139",
    "data-name": "Group 34139",
    transform: "translate(-6005.211 5976.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12898",
    "data-name": "Rectangle 12898",
    width: 5.677,
    height: 5.496,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12899",
    "data-name": "Rectangle 12899",
    width: 5.677,
    height: 5.496,
    transform: "translate(5.642 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12900",
    "data-name": "Rectangle 12900",
    width: 5.677,
    height: 5.496,
    transform: "translate(11.285 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34140",
    "data-name": "Group 34140",
    transform: "translate(-6005.211 5981.796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12901",
    "data-name": "Rectangle 12901",
    width: 5.677,
    height: 5.496,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12902",
    "data-name": "Rectangle 12902",
    width: 5.677,
    height: 5.496,
    transform: "translate(5.642 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12903",
    "data-name": "Rectangle 12903",
    width: 5.677,
    height: 5.496,
    transform: "translate(11.285 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34141",
    "data-name": "Group 34141",
    transform: "translate(-6005.211 5987.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12904",
    "data-name": "Rectangle 12904",
    width: 5.677,
    height: 5.496,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12905",
    "data-name": "Rectangle 12905",
    width: 5.677,
    height: 5.496,
    transform: "translate(5.642 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12906",
    "data-name": "Rectangle 12906",
    width: 5.677,
    height: 5.496,
    transform: "translate(11.285 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34142",
    "data-name": "Group 34142",
    transform: "translate(-6005.211 5992.859)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12907",
    "data-name": "Rectangle 12907",
    width: 5.677,
    height: 5.496,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12908",
    "data-name": "Rectangle 12908",
    width: 5.677,
    height: 5.496,
    transform: "translate(5.642 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12909",
    "data-name": "Rectangle 12909",
    width: 5.677,
    height: 5.496,
    transform: "translate(11.285 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34143",
    "data-name": "Group 34143",
    transform: "translate(-6005.211 5998.357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12910",
    "data-name": "Rectangle 12910",
    width: 5.677,
    height: 5.496,
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12911",
    "data-name": "Rectangle 12911",
    width: 5.677,
    height: 5.496,
    transform: "translate(5.642)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12912",
    "data-name": "Rectangle 12912",
    width: 5.677,
    height: 5.496,
    transform: "translate(11.285)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameSwitchSec);
export default __webpack_public_path__ + "static/media/game-switch-sec.bd456c694e41936031e2a1ba638e2d44.svg";
export { ForwardRef as ReactComponent };